import { Badge, type BadgeProps } from "@mui/material";
import type { FC } from "react";

export const NavbarBadge: FC<BadgeProps> = ({ badgeContent, sx, ...rest }) => {
  return (
    <Badge
      color="secondary"
      badgeContent={badgeContent}
      overlap="circular"
      sx={{
        display: "inline",
        "& .MuiBadge-badge": {
          transform: "unset",
          position: "unset",
        },
        ...sx,
      }}
      {...rest}
    />
  );
};
